import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import Button from "../../SharableInputs/Button";
import EmployeesGrid from "./EmployeesGrid";
import "./Home.scss";
import { useAuth } from "../../context/AuthContext";

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const displayName = (user?.name || "Guest").split(" ")[0]?.toUpperCase();
  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good Morning" : hour < 17 ? "Good Afternoon" : "Good Evening";

  return (
    <div className="home-page">
      <Header />
      <main className="home-content">
        <section className="home-hero-bar">
          <div className="home-hero-greeting">
            Hello <span>{displayName}</span>
            <span role="img" aria-label="wave">
              {"\u{1F44B}"}
            </span>
            , {greeting}!
          </div>
          <Button
            label="Start E-Verify"
            primary
            className="home-start-btn"
            onClick={() => navigate("/initiateeverify")}
          />
        </section>

        <EmployeesGrid />
      </main>
      <Footer />
    </div>
  );
}
